<template>
    <!-- 메인팝업 -->
    <div class="popup" :class="{ active: main_popup }" v-if="popupCnt > 0">
        <div class="main-popup">
            <h3 class="main-popup--title">
                <img src="@/assets/resource/img/main/main-popup--title_txt.png" alt="">
                <p class="strong">POPUP ZONE</p>
            </h3>
            <div class="main-popup__cont">
                <p class="main-popup__cont--top">팝업 전체 · <span>{{popupCnt}}개</span></p>
                <div class="swiper main-popup-swiper">
                    <ul class="swiper-wrapper main-popup__list">
                        <li class="main-popup__item swiper-slide" v-for="popup in popupList">
                            <a :href="popup.link ? popup.link : 'javascript:;'" :target="popup.target">
                                <img :src="`/displayFile.do?attachNo=${ popup.attachBag.bannerImg[0].attachNo }`" :alt="popup.attachBag.bannerImg[0].altValue || '이미지'" v-if="popup.attachBag.bannerImg">
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="main-popup-swiper__button-wrap">
                    <button class="main-popup-swiper__button prev"></button>
                    <button class="main-popup-swiper__button next"></button>
                </div>
            </div>
            <div class="main-popup__button-wrap">
                <a href="javascript:;" class="main-popup__button02" @click="closePopup" style="background-image:none;">오늘 하루 열지 않기</a>
                <a href="javascript:;" class="main-popup__button" @click.prevent="main_popup_close"></a>
            </div>
        </div>
    </div>

    <!-- 쳇봇 -->
    <a href="javascript:;" class="chetbot" @click="chatbotOpen">
        <img src="../../../../assets/resource/img/main/chetbot.gif" alt="">
        <h3 class="chetbot-tit">CHATBOT</h3>
    </a>

    <!-- 쳇봇팝업 -->
    <div class="popup popup-chetbot " :class="{ active: popup_chetbot }">
        <div class="popup__inner">
            <div class="popup__tit">
                <h2>대동맥혈관병원 찾아가는 길</h2>
                <button type="button" class="popup__close" @click="popup_chetbot_active"><img
                        src="@/assets/resource/icon/close.svg" alt=""></button>
            </div>
            <div class="popup__body">
                <div class="popup-chetbot__left">
                    <div class="popup-chetbot__left__top">
                        <div class="popup-chetbot__left__top__cont">
                            <h3 class="popup-chetbot__left--title">출발지</h3>
                            <div class="select">
                                <a href="javascript:;" class="select--btn" :class="{ active: chetbot_select }"
                                    @click.prevent="activechetbot_select">{{mapStartTxt}}</a>
                                <slide-up-down :active="chetbot_select" class="select-option">
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('B1'), activechetbot_select()]">지하1층 발산역 8번출구</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('main'), activechetbot_select()]">1층 정문</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('north'), activechetbot_select()]">1층 북문</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('parking'), activechetbot_select()]">지하주차장 B3~B5</a>
                                </slide-up-down>
                            </div>
                        </div>
                        <div class="popup-chetbot__left__top__cont">
                            <h3 class="popup-chetbot__left--title">도착지</h3>
                            <h4 class="title03">이대대동맥혈관병원</h4>
                        </div>
                    </div>
                    <div class="popup-chetbot__left__bottom">
                        <div class="popup-chetbot__left__bottom__cont">
                            <p v-html="mapList[mapIndex].start"></p>
                            <span class="arrow"></span>
                            <p v-html="mapList[mapIndex].end"></p>
                        </div>
                        <div class="popup-chetbot__btn-wrap">
                            <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 1}" @click="mapIndex = 0">이전 경로</a>
                            <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 0}" @click="mapIndex = 1">다음 경로</a>
                        </div>
                    </div>
                </div>
                <div class="popup-chetbot__right">
                    <div class="popup-chetbot__img">
                        <img :src="require(`@/assets/resource/img/main/${mapList[mapIndex].src}`)" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container main">
        <div id="custom-cursor">
            <img src="@/assets/resource/img/main/MORE+.png" alt="Custom Cursor">
        </div>
        <section class="section section01 pin-spacer">
            <div class="main-visual">
                <div class="main-visual-back">
                    <img src="@/assets/resource/img/main/section01_Vector.png" alt="" class="main-visual-back01">
                    <img src="@/assets/resource/img/main/section01_gg01.png" alt="" class="main-visual-back02">
                    <img src="@/assets/resource/img/main/section01_gg02.png" alt="" class="main-visual-back03">
                    <img src="@/assets/resource/img/main/section01_gg03.png" alt="" class="main-visual-back04">
                    <img src="" alt="" class="main-visual-back05">
                </div>
                <div class="area">
                    <div class="main-visual__title">
                        <p>WORLD BEST</p>
                        <h3>이대대동맥혈관병원</h3>
                        <div class="main-visual__scrolldown">
                            <p>SCROLL</p>
                            <img src="@/assets/resource/img/main/Arrow.png" alt="">
                        </div>
                    </div>
                    <ul class="main-visual__list">
                        <li class="main-visual__list-type01">
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box01">
                                <img src="@/assets/resource/img/main/main-visual__img01.png" alt="">
                                <h4>
                                    24시간 365일 <br>
                                    EXPRESS 시스템 운영
                                </h4>
                            </a>
                        </li>
                        <li class="main-visual__list-type02">
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box02">
                                <img src="@/assets/resource/img/main/main-visual__img02.png" alt="" />
                                <h4>
                                    언제 어디서든 환자를 위한 <br>
                                    신속한 헬기 이송
                                </h4>
                            </a>
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box03">
                                <img src="@/assets/resource/img/main/main-visual__img03.png" alt="" />
                                <h4 class="blue">
                                    24시간 365일 수술 가능한 <br>
                                    하이브리드 수술실
                                </h4>
                            </a>
                        </li>
                        <!-- 가운데 메인 -->
                        <li class="main-visual__list-type03 visual gallery">
                            <span class="circle01"><img src="@/assets/resource/img/main/section01_circle.png"
                                    alt="" /></span>
                            <div class="imgBlockMain">
                                <h3>창원파티마병원은 <br> 끊임없이 학습합니다.</h3>
                                <div class="video">
                                    <!-- 동영상 소스를 require()로 로드 -->
                                    <video id="myVideo" src="@/assets/resource/video/FullSizeRender.mp4" muted
                                        playsinline loop></video>
                                </div>
                                <div class="visual-main__wrap">
                                    <div class="visual-main_back"></div>
                                    <div class="visual-main inner">
                                        <h4>살리겠습니다 <br> </h4>
                                        <h3 class="aa">‘오십시오’</h3>
                                        <div class="visual-main__con">
                                            <ul class="visual-main__list">
                                                <li class="visual-main__item">
                                                    <div class="visual-main__test">
                                                        <h4>첫 진료 예약 / <span class="c-yellow">알림톡 서비스</span></h4>
                                                        <p>
                                                            전문 상담사가 첫 진료환자 예약을 도와드립니다. <br>
                                                            상담시간 : 평일 09:00-17:00(토요일, 공휴일 제외)
                                                        </p>
                                                        <sub>
                                                            * 알림톡 서비스는 24시간 진료예약, <br>
                                                            변경/취소, 증명서 발급이 가능합니다.
                                                        </sub>
                                                    </div>
                                                    <div class="visual-main__botton">
                                                        <div class="visual-main__botton__input">
                                                            <input type="text" placeholder="성함" class="name" v-model="name">
                                                            <input type="text" placeholder="010-0000-0000" class="number" v-model="tel">
                                                        </div>
                                                        <div class="visual-main__buttom-wrap">
                                                            <a href="javascript:;" class="visual-main__buttom" @click="showPopup('firstVisible')">예약신청</a>
                                                            <a href="javascript:;" class="visual-main__buttom" @click="showPopup('alarmVisible')">
                                                                알림톡서비스 <br>
                                                                <span>(진료예약)</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="visual-main__item">
                                                    <div class="visual-main__test">
                                                        <h4>진료예약</h4>
                                                        <p>이용자에 편의에 따라 선택하여 <br> 예약하실 수 있습니다</p>
                                                    </div>
                                                    <div class="visual-main__botton">
                                                        <div class="visual-main__buttom-wrap">
                                                            <router-link to="/kr/reserve/reserve" class="visual-main__buttom">온라인 진료예약</router-link>
                                                            <router-link to="/kr/mypage/reservation/selectReservation" class="visual-main__buttom">예약확인</router-link>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="visual-main__item">
                                                    <ul class="visual-main__botton-list">
                                                        <li>
                                                            <router-link to="/kr/mypage/health/bloodMain">
                                                                <div class="img">
                                                                    <img src="@/assets/resource/img/main/visual-main__button-list1.png"
                                                                        alt="" />
                                                                </div>
                                                                <p>혈압수첩</p>
                                                            </router-link>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:;"
                                                                @click.prevent="popup_chetbot_active">
                                                                <div class="img">
                                                                    <img src="@/assets/resource/img/main/visual-main__button-list2.png"
                                                                        alt="" />
                                                                </div>
                                                                <p>찾아가는 길</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank">
                                                                <div class="img">
                                                                    <img src="@/assets/resource/img/main/visual-main__button-list3.png"
                                                                        alt="" />
                                                                </div>
                                                                <p>후원하기</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <router-link to="/kr/doctorList">
                                                                <div class="img">
                                                                    <img src="@/assets/resource/img/main/visual-main__button-list4.png"
                                                                        alt="" />
                                                                </div>
                                                                <p>의료진찾기</p>
                                                            </router-link>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="main-visual__list-type02">
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box04">
                                <img src="@/assets/resource/img/main/main-visual__img05.png" alt="" />
                                <h4 class="blue">대동맥환자만을 위한 전용 병동</h4>
                            </a>
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box05">
                                <img src="@/assets/resource/img/main/main-visual__img06.jpg" alt="" />
                                <h4>
                                    세계 최초 <br>
                                    대동맥혈관재활치료실 OPEN!
                                </h4>
                            </a>
                        </li>
                        <li class="main-visual__list-type01">
                            <a href="javascript:;" class="main-visual__list-box main-visual__list-box06">
                                <img src="@/assets/resource/img/main/main-visual__img07.png" alt="" />
                                <h4>
                                    가족간병 걱정없는 <br>
                                    간호⠂간병 통합서비스
                                </h4>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="section section02">
            <ul class="section02__backgroundtext">
                <li>
                    <img src="@/assets/resource/img/main/section02__backgroundtext1.png" alt="">
                </li>
                <li>
                    <img src="@/assets/resource/img/main/section02__backgroundtext2.png" alt="">
                </li>
            </ul>
            <div class="inner">
                <div class="section02__background">
                    <img class="section02__background-ball1"
                        src="@/assets/resource/img/main/section02__background-ball.png" alt="">
                    <img class="section02__background-ball2"
                        src="@/assets/resource/img/main/section02__background-ball2.png" alt="">
                    <img class="section02__background-ball3"
                        src="@/assets/resource/img/main/section02__background-ball3.png" alt="">
                    <span class="section02__background-smollball no1"></span>
                    <span class="section02__background-smollball no2"></span>
                    <span class="section02__background-smollball no3"></span>
                    <span class="section02__background-smollball no4"></span>
                    <span class="section02__background-smollball no5"></span>
                    <span class="section02__background-smollball no6"></span>
                </div>

                <div class="section02_top_title transition01">
                    <h4>
                        압도적 1위,<br class="show-mo">
                        국내 최초 대동맥혈관병원 <br>
                        이대대동맥혈관병원입니다
                    </h4>
                </div>
                <div>

                </div>
                <div class="swiper section02-swiper">
                    <div class="section02__list transition02 swiper-wrapper">
                        <div :class="`section02__list--aa swiper-slide section02__list--item0${idx + 1}`" v-for="(doctor, idx) in doctorList">
                            <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                                <div class="section02__list--item--img">
                                    <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs">
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="section02-swiper-button-wrap">
                        <button class="section02-swiper-button-next"></button>
                        <button class="section02-swiper-button-prev"></button>
                    </div>
                </div>
                <div class="swiper section02-swiper2">
                    <div class="section02_bottom_title transition02 swiper-wrapper">
                        <div :class="{'swiper-slide': true, 'on': idx == 2}" v-for="(doctor, idx) in doctorList">
                            <h4>{{doctor.name}} 교수</h4>
                            <p>{{doctor.detailField}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="section section03">
            <div class="swiper section03_list-back">
                <div class="swiper-wrapper">

                    <div class="swiper-slide section03_list-back--box">
                        <div class="section03_list-back--box_on">
                            <img src="@/assets/resource/img/main/section03-back1.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide section03_list-back--box">
                        <div class="section03_list-back--box_on">
                            <img src="@/assets/resource/img/main/section03-back2.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide section03_list-back--box">
                        <div class="section03_list-back--box_on">
                            <img src="@/assets/resource/img/main/section03-back3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide section03_list-back--box">
                        <div class="section03_list-back--box_on">
                            <img src="@/assets/resource/img/main/section03-back4.png" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide section03_list-back--box">
                        <div class="section03_list-back--box_on">
                            <img src="@/assets/resource/img/main/section03-back5.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="section__title transition01">
                <h3>센터소개</h3>
                <p>압도적 1위, 국내 최초 대동맥혈관병원의 센터들을 소개합니다.</p>
            </div>
            <div class="transition02">
                <div class="swiper section03_list">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide section03_list--box">
                            <div class="section03_list--box_on">
                                <img src="@/assets/resource/img/main/section03_5-back.png" alt="">
                            </div>
                        </div>
                        <div class="swiper-slide section03_list--box">
                            <div class="section03_list--box_on">
                                <img src="@/assets/resource/img/main/section03_4-back.png" alt="">
                            </div>
                        </div>
                        <div class="swiper-slide section03_list--box">
                            <div class="section03_list--box_on">
                                <img src="@/assets/resource/img/main/section03_3-back.png" alt="">
                            </div>
                        </div>
                        <div class="swiper-slide section03_list--box">
                            <div class="section03_list--box_on">
                                <img src="@/assets/resource/img/main/section03_2-back.png" alt="">
                            </div>
                        </div>
                        <div class="swiper-slide section03_list--box">
                            <div class="section03_list--box_on">
                                <img src="@/assets/resource/img/main/section03_1-back.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section03_list2_warp">
                    <div class="section03_list2-button">
                        <button class="section03_list2-button-prev">
                            <img src="@/assets/resource/img/main/section02-swiper-button-prev02.png" alt="">
                        </button>
                        <button class="section03_list2-button-next">
                            <img src="@/assets/resource/img/main/section02-swiper-button-next02.png" alt="">
                        </button>
                    </div>
                    <div class="swiper section03_list2">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=aor')">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_1.png" alt="">
                                    <h4>Aorta Center</h4>
                                    <div class="text">
                                        <h3>대동맥센터</h3>
                                        <p>
                                            심장혈관외과, 영상의학과 인터벤션, 심혈관마취과, 응급실, 수술실, <br>
                                            중환자실, 대동맥질환 전문 간호인력, 전용 병동 등 모든 의료인력과 <br>
                                            시설을 갖추고, 24시간 제일 대동맥질환의 첨병 역할을 하고 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=PBV')">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_2.png" alt="">
                                    <h4>Peripheral<br> Vascular Center</h4>
                                    <div class="text">
                                        <h3>말초혈관센터</h3>
                                        <p>
                                            숙련된 외과, 영상의학과, 인터벤션 의사들, 혈관 의학 <br>
                                            전문가들이 합심하여 최첨단 진단 기술과 치료 방법을 사용해 <br>
                                            환자들에게 최상의 치료를 제공할 것입니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=bh001')">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_3.png" alt="">
                                    <h4>Vascular<br> Health Center
                                    </h4>
                                    <div class="text">
                                        <h3>혈관건강센터</h3>
                                        <p>
                                            최고의 의료진과 함께 환자 개인에게 맞춤형 상담을 통해 <br>
                                            비만과 대사질환을 찾아 체계적으로 분석하고 <br>
                                            한분 한분에게 가장 좋은 맞춤식 의료 서비스를 제공합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=DAC')">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_4.png" alt="">
                                    <h4>Hemodialysis <br> Vascular Center</h4>
                                    <div class="text">
                                        <h3>투석혈관센터</h3>
                                        <p>
                                            한 번의 병원 방문으로 투석혈관 문제를 해결할 수 있도록 하여 <br>
                                            환자의 편의성과 안정성을 최대한 도모하고 <br>
                                            최고의 의료 서비스를 제공하는 것이 투석혈관센터의 목표입니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=MSC')">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_5.png" alt="">
                                    <h4>Marfan Syndrome/ Hereditary Aortic <br> Disease Center</h4>
                                    <div class="text">
                                        <h3>말판증후군·유전성대동맥질환센터</h3>
                                        <p>
                                            연간 약 600례 및 10년간 약 3,000례가 넘는 대동맥 수술 전문 의료진이 <br>
                                            유전성 대동맥 질환 환자들에게 정밀 진단, 유전 상담과 가족 상담을<br> 제공해
                                            가족 단위로 치료하는 ‘말판증후군·유전성대동맥질환센터’ 입니다
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section05">
            <div class="section__title transition01">
                <h3>홍보영상</h3>
                <p>이대대동맥혈관병원의 다양한 모습들을 확인하실 수 있습니다</p>
            </div>
            <div class="inner transition02">
                <div class="section05_list">
                    <div class="section05_list--box">
                        <div class="section05_list--box--item" :class="{ on: idx == promotionIdx }" v-for="(i, idx) in promotionList">
                            <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${$commonUtils.getYoutubeId(i)}`"
                                :title="i.title" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                    <ul>
                        <li :class="{ on: idx == promotionIdx }" v-for="(i, idx) in promotionList">
                            <a href="javascript:;" @click.prevent="promotionIdx = idx">
                                <div class="img">
                                    <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(i)}/mqdefault.jpg`" alt="이미지">
                                </div>
                                <div class="text">
                                    <p>{{i.title}}</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </section>
        <section class="section section06">
            <div class="section__title transition01">
                <h3>병원소식</h3>
                <router-link :to="`/kr/${noticeBoardId}/list`" class="plus">
                    View more
                </router-link>
            </div>
            <div class="inner transition02">
                <div class="swiper section06_list">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide section06_list--box" :class="i.boardId.includes('notice') ? 'tag01' : 'tag02'" v-for="(i, idx) in mainList">
                            <component :is="i.boardId.indexOf('news') > -1 ? 'a' : 'router-link'" :href="i.linkUrl" :to="`/${$store.getters.getLang}/${i.boardId}/view?boardNo=${i.boardNo}&articleNo=${i.articleNo}`" :target="i.boardId.indexOf('news') > -1 ? '_blank' : '_self'" class="header-menu--main-link">
                                <div class="text">
                                    <h4>{{i.title}}</h4>
                                    <p>{{$commonUtils.removeTags(i.content)}}</p>
                                </div>
                                <div class="bottom">
                                    <!-- tag01: 공지사항, tag02: 언론보도 -->
                                    <span>{{i.boardId.includes('notice') ? '공지사항' : '언론보도'}}</span>
                                    <p>{{$commonUtils.dateToStr(new Date(i.createdDt), '.')}}</p>
                                </div>
                            </component>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section class="section section07">
            <div class="section__title transition01">
                <h3>후원안내</h3>
            </div>
            <div class="inner">
                <div class="section07_list">
                    <div class="section07_list--button transition04">
                        <p><strong>최고의 의료 인프라 구축</strong>으로<br class="show-mo">
                            희망의 기회를 만듭니다</p>
                        <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank">후원하기</a>
                    </div>
                    <div class="section07_list--box transition02">
                        <img src="@/assets/resource/img/main/section07_list--box.png" alt="">
                    </div>
                    <div class="section07_list--box transition03">
                        <img src="@/assets/resource/img/main/section07_list--box2.jpg" alt="">
                    </div>

                </div>

            </div>
        </section>
    </div>
    <div class="footer__center-wrap">
        <div class="footer__center-list">
            <ul>
                <li class="footer__center-item">
                    <a href="javascript:;" class="footer__center-link"><span class="name">EWHA FAMILY</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="https://www.eumc.ac.kr/main.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name">의료원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="https://mokdong.eumc.ac.kr/main.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name">이대목동병원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="https://seoul.eumc.ac.kr/main.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name">이대서울병원</span></a>
                </li>
                <li class="footer__center-item">
                    <div class="effect-icon"></div>
                    <a href="https://part.eumc.ac.kr/dept/pogoonyogoan/index.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name"><img
                                src="@/assets/resource/img/main/bogu_logo.png" alt=""
                                style="margin-right: 5px;">보구녀관</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="http://aorta.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대대동맥혈관병원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="http://ewhabrain.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대뇌혈관병원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="http://mombaby.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대엄마아기병원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="https://wch.eumc.ac.kr/main.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name">이대여성암병원</span></a>
                </li>
                <li class="footer__center-item">
                    <a href="https://ewui.eumc.ac.kr/main.do" target="_blank" title="새 창 열기" class="footer__center-link"> <span class="name">이대비뇨기병원</span></a>
                </li>
                <li class="footer__center-item">
                        <a href="https://blood.eumc.ac.kr/" class="footer__center-link" target="_blank"> <span class="name">이대혈액암병원</span></a>
                </li>
            </ul>
        </div>
    </div>
    <kr_FirstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
    <kr_AlarmTalkPopup :popupVisible="alarmVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
</template>

<script>
import { gsap } from 'gsap';  // gsap 임포트
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.css';  // Swiper 스타일 추가
import SlideUpDown from 'vue-slide-up-down';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
gsap.registerPlugin(ScrollTrigger);

import { nextTick } from 'vue';
export default {
    name: 'MainComponent',
    components: {
        SlideUpDown,
    },
    data(){
        return {
            firstVisible: false,
            alarmVisible: false,
            name: '',
            tel: '',

            lineCnt: 0,
            lineList: [],
            popupCnt: 0,
            popupList: [],

            mainList: [],
            noticeBoardId: '',
            promotionList: [],
            promotionIdx: 0,

            main_popup: true,
            main_line: false,
            chetbot_select: false,
            popup_chetbot: false,
            section05_list: true,
            section05_list02: false,
            mainHandleScroll: null,

            drSids: '1004540,1005101,1012649,1019621,1019623,1019794',
            doctorList: [],

            mapList: [
                {src: 'map_B1.jpg', start: '지하1층 발산역 8번출구', end: '외래전용 엘리베이터<br>& 에스컬레이터'},
                {src: 'map_3F.jpg', start: '3층 하차', end: '엘리베이터 좌측 위치<br>이대대동맥혈관병원'}
            ],
            mapIndex: 0,
            mapStartTxt: '지하1층 발산역 8번출구'
        };
    },
    mounted() {
        this.getMainBanner()
        this.getMainBoardList()
        this.getDoctorList()

        this.deptSwipers()

        function mainScrollFnc(){
            var now = $(window).scrollTop();
            var target01 = $('.section01').offset().top - 112;
            var target02 = $('.section02').offset().top - 600;
            var target03 = $('.section03').offset().top - 600;
            var target05 = $('.section05').offset().top - 600;
            var target06 = $('.section06').offset().top - 600;
            var target07 = $('.section07').offset().top - 600;

            if (now > target01) {
                $('.section01').addClass('on');
            }
            if (now > target02) {
                $('.section02').addClass('on');
            }
            if (now > target03) {
                $('.section03').addClass('on');
            }
            if (now > target05) {
                $('.section05').addClass('on');
            }
            if (now > target06) {
                $('.section06').addClass('on');
            }
            if (now > target07) {
                $('.section07').addClass('on');
            }
        }

        function mainScrollOffsetFnc(){
            var now = $(window).scrollTop();
            // 화면 크기를 확인하여 모바일인지 데스크탑인지 구분
            var offsetValue = $(window).width() <= 720 ? 170 : 400; // 768px 이하일 경우 모바일로 간주, 오프셋을 100으로 설정
            var targets01 = $('.section01').offset().top + 300;
            var targets02 = $('.section02').offset().top - offsetValue;
            var targets03 = $('.section03').offset().top - offsetValue;
            var targets05 = $('.section05').offset().top - offsetValue;
            var targets06 = $('.section06').offset().top - offsetValue;
            var targets07 = $('.section07').offset().top - offsetValue;

            if (now > targets01) {
                $('.section').removeClass('white')
                $('.visual-main').removeClass('white')
                $('.section01').addClass('white');
            }
            if ($(window).width() <= 1024) {
                var target01_02 = $('.visual-main').offset().top - offsetValue;
                if (now > target01_02) {
                    $('.visual-main').addClass('white')
                }
            }
            if (now > targets02) {
                $('.section').removeClass('white')
                $('.visual-main').removeClass('white')
                $('.section02').addClass('white');
            }
            if (now > targets03) {
                $('.section').removeClass('white')
                $('.section03').addClass('white');
            }
            if (now > targets05) {
                $('.section').removeClass('white')
                $('.section05').addClass('white');
            }
            if (now > targets06) {
                $('.section').removeClass('white')
                $('.section06').addClass('white');
            }
            if (now > targets07) {
                $('.section').removeClass('white')
                $('.section07').addClass('white');
            }
            if (now > targets01) {
                $('.visual-main__wrap').addClass('on');
            }
        }

        // jQuery 스크롤 이벤트 추가
        this.mainHandleScroll = () => {
            mainScrollFnc();
            mainScrollOffsetFnc();
        };

        window.addEventListener('scroll', this.mainHandleScroll)
        // $(function () {

        //     const handleScroll = () => {
        //         mainScrollFnc();
        //         mainScrollOffsetFnc();
        //     };
            
        //     $(window).on('scroll', handleScroll);

        //     $(window).on('beforeunload', function() {
        //         $(window).off('scroll', handleScroll);
        //     });
        // });

        // 화면 크기를 체크하고 1024px 이상인 경우 다른 애니메이션을 적용
        const screenWidth = window.innerWidth

        if (screenWidth >= 1025) {
            // 화면 크기가 1024px 이상일 때 적용할 애니메이션

            setTimeout(() => {
                $('.section01 .pin-spacer').addClass('on'); 
            }, 1000);
            const video = document.getElementById('myVideo');
            video.play();

            // gsap 애니메이션 추가
            let visualArea = gsap.timeline({
                scrollTrigger: {
                    trigger: '.main-visual',
                    pin: '.main-visual',
                    start: 'top top',
                    end: '+=5000',
                    scrub: 1
                }
            });

            visualArea
                .addLabel('start')
                .to('.main-visual__list-type03', { marginTop: '250px', duration: 100 }, 'start')
                .to('.main-visual__list-type02', { marginTop: '165px', duration: 100, delay: 10 }, 'start')
                .to('.main-visual__list-type01', { marginTop: '260px', duration: 140, delay: 15 }, 'start')
                .to('.main-visual__title', { opacity: 0, duration: 80 }, 'start')
                .to('.main-visual__title', { display: 'none' })
                .addLabel('start2')
                .to('.main-visual__list-type03', { height: 'calc(100dvh - 88px)', borderRadius: '0', marginTop: 0, duration: 300 }, 'start2')
                .to('.imgBlockMain', { height: 'calc(100dvh - 88px)', duration: 300 }, 'start2')
                .to('.circle01', { opacity: '0', duration: 300 }, 'start2')
                .addLabel('start3')
                .to('.imgBlockMain', { width: '100dvw', borderRadius: 0, duration: 400 }, 'start3')
                .to('.imgBlockMain', { duration: 400 })
                .to('.imgBlockMain > h3', { opacity: 0, duration: 0 })
                .addLabel('start3-5')
                .to('.visual-main__wrap', { opacity: '1', duration: 400 }, 'start3-5')
                .to('.visual-main_back', { opacity: '1', duration: 400 }, 'start3-5')
                .addLabel('start4')
                .to('.visual-main', { opacity: '1', duration: 400 }, 'start4')
                .to('.visual-main h3', { opacity: '1', duration: 500 }, 'start4')
                .to('.visual-main > h4', { opacity: '1', duration: 500 }, 'start4')
                .to('.visual-main__list', { opacity: '1', duration: 600 }, 'start4')
                .to('.visual-main__con', { height: '340px', duration: 600 }, 'start4')
                .to('.chetbot', { opacity: '1', pointerEvents: 'initial', duration: 600 }, 'start4')
                .addLabel('start5')
                .addLabel('end')
                .to('.imgBlockMain', { delay: 300 }, 'end');
        } else {
            $('body').addClass('on'); 
            setTimeout(() => {
                $('.section01.pin-spacer').addClass('on'); 
            }, 6000);
            setTimeout(() => {
                $('body').removeClass('on'); 
            }, 7000);
            setTimeout(function() {
                const video = document.getElementById('myVideo');
                if (video) {
                    video.play(); // 7초 후 영상 재생
                }
            }, 7000);
        }
        gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.section02', start: 'top bottom', end: '-100%', scrub: true }, bottom: '0' });
        gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.footer', start: 'top bottom', scrub: true, toggleClass: { targets: '.footer__center-list', className: 'on' } } });
    },
    beforeDestroy() {
        // 컴포넌트 파괴 시 Swiper 인스턴스를 정리 (메모리 누수 방지)
        if (this.swiperMain) this.swiperMain.destroy();
        if (this.swiper3_2) this.swiper3_2.destroy();
        if (this.swiper3) this.swiper3.destroy();
        if (this.swiper3_3) this.swiper3_3.destroy();

        // 컴포넌트가 파괴될 때 이벤트 리스너 제거
        window.removeEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.mainHandleScroll)
    },
    methods: {
        setMapList(start){
            this.mapIndex = 0
            this.mapList = []
            if(start == 'B1'){
                this.mapStartTxt = '지하1층 발산역 8번출구'
                const obj = {src: 'map_B1.jpg', start: '지하1층 발산역 8번출구', end: '외래전용 엘리베이터<br>& 에스컬레이터'}
                this.mapList.push(obj)
            }else if(start == 'main'){
                this.mapStartTxt = '1층 정문'
                const obj = {src: 'map_1F_maingate.jpg', start: '1층 정문', end: '외래전용 엘리베이터<br>& 에스컬레이터'}
                this.mapList.push(obj)
            }else if(start == 'north'){
                this.mapStartTxt = '1층 북문'
                const obj = {src: 'map_1F_northgate02.jpg', start: '1층 북문', end: '외래전용 엘리베이터<br>& 에스컬레이터'}
                this.mapList.push(obj)
            }else if(start == 'parking'){
                this.mapStartTxt = '지하주차장 B3~B5'
                const obj = {src: 'map_parkingGarage.jpg', start: '지하주차장 B3~B5', end: '외래전용 엘리베이터<br>& 에스컬레이터<br>(주차 위치: F, G, H, I)'}
                this.mapList.push(obj)
            }
            const obj = {src: 'map_3F.jpg', start: '3층 하차', end: '엘리베이터 좌측 위치<br>이대대동맥혈관병원'}
            this.mapList.push(obj)
        },
        getDoctorList(){
            const param = {
                startIndex: 1,
                drName: this.drName,
                pageRow: 100,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                drSids: this.drSids
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                const arr = res.data.doctorList
                this.doctorList = this.$commonUtils.distinctList(arr, 'name')
                
                if(arr && arr.length > 0){
                    const item = this.doctorList[2]
                    this.doctorList[2] = this.doctorList[1]
                    this.doctorList[1] = item
                }

                nextTick(() => {
                    // 모바일 swiper
                    const screenWidth = window.innerWidth
                    if (screenWidth <= 720) {
                        this.swiper2_2 = new Swiper('.section02-swiper2', {
                            slidesPerView: 1,
                            spaceBetween: 40,
                            slidesPerGroup: 1,
                            initialSlide: 2,
                        }); 
                    }
                    // 의료진 소개 이벤트
                    $('.section02__list .section02__list--aa .section02__list--item').click(function(event) {
                        event.preventDefault(); // 링크의 기본 동작 방지
                        var index = $(this).parent().index(); // 클릭한 링크의 부모 div 요소의 인덱스 가져오기
                        $('.section02_bottom_title div').removeClass('on'); // 모든 p 요소에서 'on' 클래스 제거
                        $('.section02_bottom_title div').eq(index).addClass('on'); // 해당 인덱스에 맞는 p 요소에 'on' 클래스 추가
                    });
                    $(".section02__list a").click(function(){
                        var classes = $(this).attr('class').split(' ');
                        if(!$(this).hasClass('doctor03')){
                            $(".doctor03").addClass(classes);
                            $(".doctor03").removeClass("doctor03");
                            $(this).removeClass(classes);
                            $(this).addClass("doctor03 cursor section02__list--item");
                        }else{
                            const drSid = $(this).data('drsid')
                            const deptCd = $(this).data('deptcd')
                            window.open(`/kr/doctorInfo?drSid=${drSid}&deptCd=${deptCd}`, '_blank')
                        }
                    });
                })
            })
        },
        chatbotOpen(){
            const w = 450
            const h = 550
            let xPos = (document.body.offsetWidth/2) - (w/2);
            xPos += window.screenLeft; // 듀얼 모니터일 때
            const yPos = (document.body.offsetHeight/2) - (h/2);

            window.open('https://pf.kakao.com/_xdvyYT/chat?bot=true', "chatbot", `width=${w}, height=${h}, left=${xPos}, top=${yPos}, menubar=yes, status=yes, titlebar=yes, resizable=yes`);
        },
        getMainBoardList() {
            const param = {
                pageRow: 6
            }
            this.axios.get(this.api.article.main, {
                params: param
            })
                .then(res => {
                    const list = res.data
                    if(list){
                        const hostName = location.hostname.split('.')[0];
                        let prefix = 'aorta'
                        if (hostName == 'ewhabrain') {
                            prefix = 'vie';
                        } else if (hostName == 'mombaby') {
                            prefix = 'vie';
                        }
                        this.noticeBoardId = list['notice'].length > 0 ? list['notice'][0].boardId : `${prefix}_notice`
                        this.mainList = list['all']
                        this.$commonUtils.objArrSort(this.mainList, 'createdDt', 'DESC')
                    }
                    this.promotionList = list['promotion'].slice(0, 2)

                    // Swiper 초기화
                    nextTick(() => {
                        this.boardSwipers();
                    });
                })
        },
        showPopup(param){
            if(!this.name || !this.tel){
                alert('성함과 휴대전화번호를 입력해주세요.')
                return
            }
            this[param] = true
        },
        hidePopup(param){
            this[param] = false
            this.name = ''
            this.tel = ''
        },
        getMainBanner() {
            const param = {
                hospId: this.$store.getters.getHost
            }
            this.axios.get(this.api.banner.main, {
                params: param
            }).then(res => {
                // 띠배너
                // const line = res.data.line
                // this.lineCnt = line.totCnt
                // this.lineList = line.list

                // if(this.lineCnt > 0){
                //     this.main_line = true

                //     const oneDay = 24 * 60 * 60 * 1000
                //     const now = new Date().getTime()

                //     const lineLastVisit = localStorage.getItem('lineTime')
                //     const lineLastVisitTime = lineLastVisit ? parseInt(lineLastVisit, 10) : null
                //     const lineTimeSinceLastVisit = lineLastVisitTime ? now - lineLastVisitTime : null

                //     if (lineLastVisitTime && lineTimeSinceLastVisit < oneDay) {
                //         this.main_line = false;
                //     }
                // }else{
                //     this.main_line = false
                // }

                // 팝업
                const popup = res.data.popup
                this.popupCnt = popup.totCnt
                this.popupList = popup.list

                if(this.popupCnt > 0){
                    this.main_popup = true

                    const oneDay = 24 * 60 * 60 * 1000
                    const now = new Date().getTime()

                    const popupLastVisit = localStorage.getItem('popupTime')
                    const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null
                    const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null

                    if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                        this.main_popup = false;
                    }

                    // Swiper 초기화
                    nextTick(() => {
                        this.popupSwipers();
                    });
                }else{
                    this.main_popup = false
                }
            })
        },
        closePopup() {
            this.main_popup = false;
            const now = new Date().getTime()
            localStorage.setItem('popupTime', now.toString())
        },
        main_popup_close() {
            this.main_popup = false;
        },
        popup_chetbot_active() {
            this.popup_chetbot = !this.popup_chetbot;
        },
        activechetbot_select() {
            this.chetbot_select = !this.chetbot_select;
        },
        section05_list_active() {
            this.section05_list = true;
            this.section05_list02 = false;
        },
        section05_list02_active() {
            this.section05_list02 = true;
            this.section05_list = false;
        },

        popupSwipers() {
            this.main_popup_swiper = new Swiper('.main-popup-swiper', {
                slidesPerView: 1,
                speed: 600,
                spaceBetween: 40,
                breakpoints: {
                    // 720 이상일 때
                    720: {
                        slidesPerView: 2,
                    },
                    // 1312 이상일 때
                    1312: {
                        slidesPerView: 3,
                    },
                },
            });
            document.querySelector('.main-popup-swiper__button.next').addEventListener('click', () => {
                if (this.main_popup_swiper) {
                    this.main_popup_swiper.slideNext();
                }
            });

            document.querySelector('.main-popup-swiper__button.prev').addEventListener('click', () => {
                if (this.main_popup_swiper) {
                    this.main_popup_swiper.slidePrev();
                }
            });
        },


        deptSwipers() {
            // 메인 슬라이드
            this.swiperMain = new Swiper('.main-visual__slide', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                delay: 3000
                },
                speed: 600,
            });

            // section03_list2 슬라이드
            this.swiper3_2 = new Swiper('.section03_list2', {
                slidesPerView: 1,        // 한 번에 보여줄 슬라이드 수
                touchRatio: 0.4,         // 터치 비율 (슬라이드 조작 반응도)
                loop: true,              // 루프 설정
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,         // 자동 전환 시간 (4초)
                    disableOnInteraction: false, // 상호작용 후 자동 전환 유지
                },
                speed: 300,             // 전환 속도 (1초)
                fadeEffect: {
                    crossFade: true,     // 교차 페이드 효과를 활성화 (슬라이드가 겹쳐서 전환)
                },
                navigation: {
                    nextEl: '.section03_list2-button-next',
                    prevEl: '.section03_list2-button-prev',
                },
                breakpoints: {
                    // 1024 이상일 때
                    720: {
                        speed: 1000,
                    },
                },
            });

            // section03_list 슬라이드
            this.swiper3 = new Swiper('.section03_list', {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 150,
                loop: true,
                speed: 1000,
            });

            // section03_list-back 슬라이드
            this.swiper3_3 = new Swiper('.section03_list-back', {
                slidesPerView: 1,
                loop: true,
                speed: 0,
            });

            document.querySelector('.section03_list2-button-next').addEventListener('click', () => {
                if (this.swiper3_2) {
                    this.swiper3_2.slideNext();
                }
            });

            document.querySelector('.section03_list2-button-prev').addEventListener('click', () => {
                if (this.swiper3_2) {
                    this.swiper3_2.slidePrev();
                }
            });

            // swiper3_2가 스와이프될 때 swiper3도 같은 방향으로 스와이프
            this.swiper3_2.on('slideNextTransitionStart', () => {
                this.swiper3.slidePrev();
                this.swiper3_3.slideNext();
                this.toggleWarpClass();
            });

            this.swiper3_2.on('slidePrevTransitionStart', () => {
                this.swiper3.slideNext();
                this.swiper3_3.slidePrev();
                this.toggleWarpClass();
            });
        },

        boardSwipers() {
            // section06_list 슬라이드
            this.swiper = new Swiper('.section06_list', {
                slidesPerView: 1.2,
                spaceBetween: 20,
                loop: true,
                breakpoints: {
                    // 1024 이상일 때
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40, // 간격을 30으로 변경
                    },
                },

            });
            const screenWidth = window.innerWidth
            if (screenWidth <= 720) {
                this.swiper2 = new Swiper('.section02-swiper', {
                    touchRatio: 0.4,
                    slidesPerView: 1,
                    spaceBetween: 40,
                    slidesPerGroup: 1,
                    initialSlide: 2,
                });
                // setTimeout(() => {
                //     this.swiper2_2 = new Swiper('.section02-swiper2', {
                //         slidesPerView: 1,
                //         spaceBetween: 40,
                //         slidesPerGroup: 1,
                //         initialSlide: 2,
                //     }); 
                // }, 4000);
                this.swiper2.on('slideNextTransitionStart', () => {
                    this.swiper2_2.slideNext();
                });

                this.swiper2.on('slidePrevTransitionStart', () => {
                    this.swiper2_2.slidePrev();
                });
                document.querySelector('.section02-swiper-button-next').addEventListener('click', () => {
                    if (this.swiper2) {
                        this.swiper2.slideNext();
                        this.toggleWarpClass02();
                    }
                });
    
                document.querySelector('.section02-swiper-button-prev').addEventListener('click', () => {
                    if (this.swiper2) {
                        this.swiper2.slidePrev();
                        this.toggleWarpClass02();
                    }
                });


                 // Intersection Observer API 설정
                const sections = document.querySelectorAll('.section');

                // 옵저버 콜백 함수: 섹션이 화면에 보일 때 'active' 클래스를 추가
                const observerOptions = {
                threshold: 0.5 // 50% 이상 보일 때 트리거
                };

                const observerCallback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                    // 섹션이 화면에 보이면 'active' 클래스 추가
                    entry.target.classList.add('active');

                    // GSAP을 사용한 애니메이션: 섹션이 보일 때 투명도와 배경색을 변경
                    gsap.to(entry.target, {
                        opacity: 1,
                        duration: 1,  // 1초 동안 서서히 나타나게
                        ease: 'power3.out' // 애니메이션 효과
                    });
                    } else {
                    // 섹션이 화면에서 벗어나면 'active' 클래스 제거
                    entry.target.classList.remove('active');
                    }
                });
                };

                const observer = new IntersectionObserver(observerCallback, observerOptions);

                // 모든 섹션에 대해 Intersection Observer 적용
                sections.forEach(section => {
                observer.observe(section);
                });
                
            };

        },
        toggleWarpClass() {
            const screenWidth = window.innerWidth
            if (screenWidth <= 720) {
                const warp = document.querySelector('.section03_list2_warp');
                if (warp) {
                    warp.classList.add('on');
                    setTimeout(() => {
                    warp.classList.remove('on');
                    }, 300);
                }
            } else{
                const warp = document.querySelector('.section03_list2_warp');
                if (warp) {
                    warp.classList.add('on');
                    setTimeout(() => {
                    warp.classList.remove('on');
                    }, 1000);
                }
            }
        },
        toggleWarpClass02() {
            const warp = document.querySelector('.section02');
            if (warp) {
                warp.classList.add('active');
                setTimeout(() => {
                warp.classList.remove('active');
                }, 300);
            }
        },
        
    }
}
</script>
<style scoped></style>
